import { type FC, type ReactElement } from "react";
import * as styles from "./styles.css";

type Props = {
  children: ReactElement | ReactElement[];
};

export const JobList: FC<Props> = ({ children }) => <dl className={styles.jobList}>{children}</dl>;
